export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Dario Parapente
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Experience the freedom of flight with certified tandem paragliding adventures. Creating unforgettable memories in the sky since 2014.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  About
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('experiences')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Experiences
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Gallery
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('booking')} className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">
                  Book Now
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start text-sm">
                <i className="ri-phone-fill text-sky-400 mr-3 mt-0.5"></i>
                <span className="text-gray-400">0034603904525</span>
              </li>
              <li className="flex items-start text-sm">
                <i className="ri-mail-fill text-sky-400 mr-3 mt-0.5"></i>
                <span className="text-gray-400">darioparapentetandem@gmail.com</span>
              </li>
              <li className="flex items-start text-sm">
                <i className="ri-map-pin-fill text-sky-400 mr-3 mt-0.5"></i>
                <span className="text-gray-400">Andalusia, España</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-sky-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-sky-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-sky-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-sky-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-whatsapp-fill text-xl"></i>
              </a>
            </div>
            <div className="mt-6">
              <h5 className="font-semibold text-sm mb-2">Safety Certifications</h5>
              <div className="flex items-center space-x-2">
                <i className="ri-shield-check-fill text-2xl text-green-400"></i>
                <i className="ri-award-fill text-2xl text-yellow-400"></i>
                <i className="ri-verified-badge-fill text-2xl text-sky-400"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 Dario Parapente Tandem. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
